<template>
    <div>
      <v-dialog v-model="dialogyetki" persistent width="500">
        <v-card color="primary" dark>
          <v-card-text>
            <v-layout align-center="" align-start row wrap fill-height="">
              <v-flex pa-2 xs1 sm1 md1>
                <v-icon large color="white">info</v-icon>
              </v-flex>
              <v-flex pa-3 xs11 sm11 md11>
                <span class="subheading"> {{this.mesaj}} </span>
              </v-flex>
              <v-row class="ma-2" justify="center">
                <v-radio-group v-model="radios">
      <template v-slot:label>
       <div> {{ chksoru }} </div> 
       <v-divider></v-divider>
      </template>
      <v-radio value="no" color="red" >
        <template v-slot:label>
            {{ chkcevapno }}
        
        </template>
      </v-radio>
      <v-radio value="yes" color="green">
        <template v-slot:label>
            {{ chkcevapyes }}
         
        </template>
      </v-radio>
    </v-radio-group>
    </v-row>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="white"  flat @click="onay()">{{ $t('OK') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </div>
  </template>
  
  
  <script>
    import auth from '../../../api/auth'
    import helpers from "@/components/app/customcomp/helpers.js"
  
  
    export default {
      props: ["value"],
      components: {
  
      },
      computed: {
        val: {
          get: function () {
            return this.value;
          },
          set: function (newValue) {
            this.$emit('input', newValue)
          },
        },
      },
      beforeMount: beforeMount,
      filters: {
  
        dateformat: function (t) {
          return helpers.dateformat(t);
        },
        moneyformat: function (m) {
          return helpers.moneyformat(m);
        },
        bakiyekontrol: function (m) {
          return helpers.bakiyekontrol(m);
        }
  
      },
  
      methods: {
        onay() {
          this.dialogyetki = false
          if (this.radios=='yes')
          {
            this.resolve(true);
          }
          else
          {
            this.resolve(false);
          }
        },
        iptal() {
          this.resolve(false);
           this.dialogyetki = false
        },
  
  
        open(mesaj,islem,chksoru,chkcevapyes,chkcevapno) {
            this.radios='';
            this.chkcevapno=chkcevapno;
            this.chkcevapyes=chkcevapyes;
            this.chksoru=chksoru;
          if (islem == null || islem == '') {
            islem = 0
          }
          this.islem = islem
          this.mesaj = mesaj
          this.dialogyetki = true;
          return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
          });
  
        },
      },
      data() {
        return {
        chkcevapno:'',
        chkcevapyes:'',
        chksoru:'',
          radios: '',
          islem: 0,
          mesaj: null,
          alertshow: false,
          alertmodel: true,
          tahsilatbakiyem: 0,
          dialogbaslik: '',
          resolve: null,
          kaydetbuton: false,
          dialogyetki: false,
          tahsilatguncellebuton: false,
          k: null,
          doviztipi: [],
          reject: null,
          bankapositems: [],
          itemsbanka: [],
          statecaritahsilat: [],
          itemsevraktipi: [],
          tahsilatdialog: false,
          text1: null,
          searchcaritahsilat: '',
          taksitsayitahsilat: [],
          loading: false,
          snackbar: false,
          y: 'top',
          x: 'right',
          mode: '',
          timeout: 6000,
        }
      },
      watch: {
  
      },
    }
    function beforeMount() {
  
    }
  </script>